export class ProjectStageImpl {
    constructor() {
        this.fields = [];
    }
    include(...fieldNames) {
        fieldNames.forEach((fieldName) => {
            this.fields.push({ include: { fieldName } });
        });
        return this;
    }
    exclude(...fieldNames) {
        fieldNames.forEach((fieldName) => {
            this.fields.push({ exclude: { fieldName } });
        });
        return this;
    }
    with(expression, fieldName) {
        this.addField(expression, fieldName);
        return this;
    }
    withNested(stage, fieldName) {
        return this.addNestedProjectionField(fieldName, stage.fields);
    }
    addField(expression, fieldName) {
        this.fields.push({
            projectionExpression: { fieldName, expression: expression.toProto() },
        });
        return this;
    }
    addNestedProjectionField(fieldName, fields) {
        this.fields.push({ projectionFields: { fieldName, fields } });
        return this;
    }
    toProto() {
        return { projection: { fields: this.fields } };
    }
}
//# sourceMappingURL=ProjectStage.js.map